import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import config from '../config';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [signupLoading, setSignupLoading] = useState(false);
  const [signupMessage, setSignupMessage] = useState('');

  const handleSignup = async (e) => {
    e.preventDefault();
    const value = email.trim();
    if (!value) return;
    if (!value.includes('@')) {
      setSignupMessage('Please enter a valid email.');
      return;
    }
    setSignupLoading(true);
    setSignupMessage('');
    try {
      const res = await fetch(`${config.API_BASE}/api/email-signup`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ email: value }),
      });
      const data = await res.json();
      if (data.success) {
        setEmail('');
        setSignupMessage(data.alreadySubscribed ? "You're already on the list." : "Thanks — you're subscribed.");
      } else {
        setSignupMessage(data.error || 'Something went wrong. Try again later.');
      }
    } catch {
      setSignupMessage('Network error. Try again later.');
    } finally {
      setSignupLoading(false);
    }
  };

  return (
    <footer style={{
      borderTop: '1px solid #e0e0e0',
      padding: '20px 20px',
      background: '#fff',
      marginTop: '60px',
      position: 'relative',
      zIndex: 5
    }}>
      <div style={{
        maxWidth: '1040px',
        margin: '0 auto',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        flexWrap: 'wrap',
        gap: '28px 40px',
        width: '100%',
        boxSizing: 'border-box'
      }}>
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          gap: 'min(100px, 8vw)',
          flexWrap: 'wrap',
          flex: '1 1 280px'
        }}>
          <div style={{ minWidth: '160px' }}>
            <h4 style={{ fontSize: '14px', fontWeight: 'bold', marginBottom: '15px', textAlign: 'center' }}>Customer Service</h4>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0, textAlign: 'center' }}>
              <li style={{ marginBottom: '4px' }}>
                <Link to="/shipping-policy" style={{ fontSize: '13px', color: '#666', textDecoration: 'none' }}
                  onMouseEnter={(e) => { e.target.style.color = '#000'; }}
                  onMouseLeave={(e) => { e.target.style.color = '#666'; }}>
                  Shipping Policy
                </Link>
              </li>
              <li style={{ marginBottom: '4px' }}>
                <Link to="/return-policy" style={{ fontSize: '13px', color: '#666', textDecoration: 'none' }}
                  onMouseEnter={(e) => { e.target.style.color = '#000'; }}
                  onMouseLeave={(e) => { e.target.style.color = '#666'; }}>
                  Return & Refund Policy
                </Link>
              </li>
            </ul>
          </div>

          <div style={{ minWidth: '160px' }}>
            <h4 style={{ fontSize: '14px', fontWeight: 'bold', marginBottom: '15px', textAlign: 'center' }}>Legal</h4>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0, textAlign: 'center' }}>
              <li style={{ marginBottom: '4px' }}>
                <Link to="/privacy-policy" style={{ fontSize: '13px', color: '#666', textDecoration: 'none' }}
                  onMouseEnter={(e) => { e.target.style.color = '#000'; }}
                  onMouseLeave={(e) => { e.target.style.color = '#666'; }}>
                  Privacy Policy
                </Link>
              </li>
              <li style={{ marginBottom: '4px' }}>
                <Link to="/terms-conditions" style={{ fontSize: '13px', color: '#666', textDecoration: 'none' }}
                  onMouseEnter={(e) => { e.target.style.color = '#000'; }}
                  onMouseLeave={(e) => { e.target.style.color = '#666'; }}>
                  Terms & Conditions
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div style={{
          flex: '0 0 auto',
          width: '100%',
          maxWidth: '280px',
          marginLeft: 'auto',
          boxSizing: 'border-box'
        }}>
          <h4 style={{ fontSize: '13px', fontWeight: 'bold', margin: '0 0 8px 0', color: '#333' }}>Email updates</h4>
          <p style={{ fontSize: '11px', color: '#666', margin: '0 0 10px 0', lineHeight: 1.4 }}>
            Occasional news and drops. Unsubscribe anytime.
          </p>
          <form onSubmit={handleSignup} style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
            <input
              type="email"
              name="footer-email"
              autoComplete="email"
              placeholder="you@email.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              disabled={signupLoading}
              style={{
                width: '100%',
                padding: '8px 10px',
                fontSize: '13px',
                border: '1px solid #ccc',
                borderRadius: 0,
                boxSizing: 'border-box',
                backgroundColor: '#fff',
                color: '#000'
              }}
            />
            <button
              type="submit"
              disabled={signupLoading}
              style={{
                padding: '8px 12px',
                fontSize: '12px',
                fontWeight: 'bold',
                background: signupLoading ? '#999' : '#000',
                color: '#fff',
                border: 'none',
                borderRadius: 0,
                cursor: signupLoading ? 'not-allowed' : 'pointer',
                alignSelf: 'flex-start'
              }}
            >
              {signupLoading ? '…' : 'Sign up'}
            </button>
          </form>
          {signupMessage ? (
            <p style={{ fontSize: '11px', margin: '8px 0 0 0', color: signupMessage.includes('Thanks') || signupMessage.includes('already') ? '#2d6a4f' : '#c1121f' }}>
              {signupMessage}
            </p>
          ) : null}
        </div>
      </div>

      <div style={{
        textAlign: 'center',
        color: '#999',
        fontSize: '12px',
        marginTop: '20px',
        paddingTop: '15px',
        borderTop: '1px solid #f0f0f0'
      }}>
        © {new Date().getFullYear()} Bokeh. All rights reserved.
      </div>
    </footer>
  );
}
